import { formSerializeArray, formData } from './utils.js'

function noop() {}

export function initForm($form, callbacks = {}) {
    $form.addEventListener('submit', function (e) {
        e.preventDefault();

        // прокидываем загрушки для callbacks + проверка на ENABLE_CALLBACKS
        ['onErrorCallback', 'onSuccessCallback'].forEach(fxn => {
            if (typeof callbacks[fxn] !== 'function') {
                callbacks[fxn] = noop;
            }
        });

        if ($form.classList.contains('is-sending')) return;
        $form.classList.add('is-sending');

        const $modalError = $form.querySelector('.js-modal_error-text');

        // поля
        const fields             = formSerializeArray($form);
        const requiredFieldsText = $form.getAttribute('data-required-fields');
        const requiredFields     = !!requiredFieldsText ? requiredFieldsText.split(',').map(name => name.trim()) : [];
        const errorFields        = [];
        let hasErrors            = false;

        // валидация
        requiredFields.forEach(name => {
            const value = fields[name].trim();
            const $item = $form.querySelector(`[name=${name}]`);

            if ($item === null) {
                return console.log(`[name=${name}] не найден`, $form);
            }
            $item.classList.remove('error');

            const checkers = [
                // текстовое поле
                value.length === 0,

                // телефон
                name === 'phone' && !/^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10}$/i.test($item.value)
            ];

            checkers.forEach(checker => {
                if (checker
                        && errorFields.indexOf($item) === -1
                        && !$item.classList.contains('is-hidden')) {
                    errorFields.push($item);
                    $item.classList.add('error');
                }
            });
        });
        let errorMessage = 'Пожалуйста, корректно заполните поля: ';
            errorFields.forEach($item => errorMessage += $item.getAttribute('placeholder') + ', ');
            hasErrors    = errorFields.length > 0;
            errorMessage = errorMessage.replace(/[, ]+$/g, '');

        $modalError.textContent = errorMessage;
        $modalError.classList.toggle("active", hasErrors);

        var $agreement = $form.querySelector('[name="agreement"]');
        if ($agreement !== null && !$agreement.checked) {
            hasErrors = true;
            alert('Дайте согласие на обработку персональных данных');
        }

        if (!hasErrors) {
            const data = formData(fields);

            // отправка файлов
            const $fileField = $form.querySelector('input[type=file]');
            const file       = $fileField !== null ? $fileField.files[0] : undefined;

            if (typeof file !== 'undefined') {
                data.append('file', file);
            }

            // отправляем форму
            fetch('/handler/send_form', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: data,
            })
            .then(response => response.json())
            .then(r => {
                if (r.status === 'ok') {
                     // очищаем поля
                    $form.querySelectorAll('input[type=text][name], textarea[name]').forEach($item => {
                        if ($item) {
                            $item.value = '';
                            $item.classList.remove('error');
                        }
                    });

                    // закрываем модалку
                    const $modal = document.querySelector('.modal.is-active');
                    if ($modal !== null) {
                        $modal.classList.remove('is-active');
                    }

                    // показываем модалку об успешной отправке
                    if (typeof $form.dataset.showSuccesModal !== 'undefined') {
                        window.openModal('success');
                    }

                    callbacks.onSuccessCallback(r);
                } else {
                    // ошибка
                    $modalError.classList.add("active")
                    $modalError.innerHTML = r.message;

                    callbacks.onErrorCallback();
                }

                $form.classList.remove('is-sending');
            });
        } else {
            $form.classList.remove('is-sending');
            callbacks.onErrorCallback();
        }
    });
}

export function form() {

    function createMask(element) {
        let keyCode;

        const mask = (event) => {
            event.keyCode && (keyCode = event.keyCode);
            const position = element.selectionStart;
            if (position < 3 && event.keyCode != 35 && event.keyCode != 39) {
                event.preventDefault();
                element.selectionStart = element.value.length;
            }
            element.value = checkMask(event, element.value);
            if (element.value[1] == '9') {
                let valueArr = element.value.split('');
                valueArr.splice(1, 0, '7');
                let strValue = valueArr.join('');
                strValue = strValue.replace(/[^+\d]/g, '');
                element.value = checkMask(event, strValue)
            } else {
                element.value = element.value.replace(element.value[1], '7');
            }
        }

        const checkMask = (event, value) => {
            const matrix = "+7 (___) ___-__-__";
            let i = 0;
            const defaulthMask = matrix.replace(/\D/g, "");
            const elementValue = value.replace(/\D/g, "");
            let newElementValue = matrix.replace(/[_\d]/g, (a) => {
                return i < elementValue.length ? elementValue.charAt(i++) || defaulthMask.charAt(i) : a;
            });
            i = newElementValue.indexOf("_");
            if (i != -1) {
                newElementValue = newElementValue.slice(0, i);
            }
            let reg = matrix.substr(0, value.length).replace(/_+/g, (a) => {
                return "\\d{1," + a.length + "}";
            })
                .replace(/[+()]/g, "\\$&");

            reg = new RegExp("^" + reg + "$");
            if (!reg.test(value) || value.length < 5 || keyCode > 47 && keyCode < 58) {
                value = newElementValue;
            }
            if (event.type == "blur" && value.length < 5) {
                value = "";
            }
            if (event.type == "input" && value.length < 5 && keyCode > 36 && keyCode < 41) {
                event.preventDefault();
            }

            return value
        }

        element.addEventListener("input", mask, false);
        element.addEventListener("focus", mask, false);
        element.addEventListener("blur", mask, false);
        element.addEventListener("keydown", mask, false);

        return mask;
    }

    document.querySelectorAll('.js-PhoneMask').forEach(function (item) {
        createMask(item);
    });

    document.querySelectorAll('.js-form').forEach($form => initForm($form));
    document.querySelectorAll('.Form').forEach($form => initForm($form));

    $(document).ready(function(){
        $('.radio-group input').click(function(e) {
            const $form   = $(this).parents('form');
            const $input  = $('.modal_choose-type-radio input:checked', $form);
            const $phone  = $('.js-phoneField', $form);
            const $email  = $('.js-emailField', $form);

            const condition = $input.is("#blue");

            $phone.toggleClass('is-hidden', !condition);
            $email.toggleClass('is-hidden', condition);
        });

        $('[name="no_website"]').change(function () {
            $('[name="site_link"]').toggle();
        });
    });
}
